import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { Button, Modal } from "react-bootstrap";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

import { getAllEventSchedules, myOHSE } from "app/_services/ehs/ehsEventScheduleServices";
import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import { getStatusClass, MEETING_STATUS } from "./CONSTANT";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { useParams } from "react-router-dom";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { ACTIVE_MODULE } from "app/_constants/constant";

const getMeetingStatusClass = (status) => {
  switch (status) {
    case MEETING_STATUS.draft:
      return "bg-dark text-white rounded text-center";
    case MEETING_STATUS.scheduled:
      return "bg-info text-white rounded text-center px-1";
    case MEETING_STATUS.planned:
      return "bg-primary text-white rounded text-center px-1";
    case MEETING_STATUS.executed:
      return "orange";
    case MEETING_STATUS.rejected:
      return "bg-primary text-white rounded text-center px-1";
    case MEETING_STATUS.approved:
      return "success";
    case MEETING_STATUS.inProgress:
      return "orange";
    case MEETING_STATUS.reviewed:
      return "orange";
    case MEETING_STATUS.taskInProgress:
      return "orange";
    case MEETING_STATUS.taskOverDue:
      return "orange";
    case MEETING_STATUS.closed:
      return "success";
    default:
      return "notstarted";
  }
};

const EventInfoModal = ({
  meetingSummary,
  agenda,
  venue,
  site,
  event,
  owner,
  scheduleId,
  eventDate,
  eventStatus,
  type,
  participants,
  show,
  onHide,
}) => (
  <Modal size="xl" show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>Event Info</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>
        <label className="mr-2">Site Name - Site ID:</label>
        <span>{site ? `${site.name} - ${site.siteId}` : ""}</span>
      </div>
      <div>
        <label className="mr-2">Event ID:</label>
        <span>{scheduleId}</span>
      </div>
      <div>
        <label className="mr-2">Event Type:</label>
        <span>{type}</span>
      </div>
      <div>
        <label className="mr-2">Event Name:</label>
        <span>{event?.name}</span>
      </div>
      <div>
        <label className="mr-2">Owner:</label>
        <span>
          {owner?.firstName} {owner?.lastName}
        </span>
      </div>
      <div>
        <label className="mr-2">Event Date & Time:</label>
        <span>{formatDDMMYYYYbyYYYYMMDD(eventDate)}</span>
      </div>
      <div>
        <label className="mr-2">Event Status:</label>
        <span className={getMeetingStatusClass(eventStatus)}>{eventStatus}</span>
      </div>
      <div>
        <label className="mr-2">Venue:</label>
        <span>{venue}</span>
      </div>
      <div>
        <label className="mr-2">Agenda:</label>
        <p>{agenda}</p>
      </div>
      <div>
        <label className="mr-2">Meeting Summary:</label>
        <p>{meetingSummary}</p>
      </div>
      <div>
        <label className="mr-2">Participants:</label>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th scope="col">S. No.</th>
              <th scope="col">Category</th>
              <th scope="col">Email</th>
              <th scope="col">Name</th>
              <th scope="col">Attendence</th>
            </tr>
          </thead>
          <tbody>
            {participants?.map((user, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{user.category}</td>
                <td>{user.email}</td>
                <td>{user.name}</td>
                <td>{user.attended}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal.Body>
    <Modal.Footer className="justify-content-center">
      <Button variant="secondary" onClick={onHide}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);

function Event({ event, timeText }) {
  const [show, setShow] = useState(false);

  const onHide = () => setShow(false);

  return (
    <>
      <div onClick={() => setShow(true)} className="w-100 pointer">
        {/* <span style={{ height: 10, width: 15 }} className={`${getStatusClass(event.extendedProps.eventStatus)} mr-2`} /> */}
        {/* <b className="mr-1">{timeText.toUpperCase()}M</b> */}
        <span
          className={`${getMeetingStatusClass(event?.extendedProps?.eventStatus)} pl-1`}
        >
          {event.title}
        </span>
      </div>
      {show && <EventInfoModal show={show} onHide={onHide} {...event.extendedProps} />}
    </>
  );
}

function renderEventContent({ event, timeText }) {
  return <Event event={event} timeText={timeText} />;
}
//useParams
const MeetingsCalendar = ({ user, hideMenuTabs }) => {
  const [events, setEvents] = useState([]);
  let { id, siteId } = useParams();
  const [tab, setTab] = useState(+CommmonService.getQueryParam("tab") || 1);

  useEffect(() => {
    (+CommmonService.getQueryParam("type") === 1
      ? myOHSE()
      : getAllEventSchedules(`myEvents=1${siteId ? `&filter[siteId]=${siteId}` : ""}`)
    ).then((response) => {
      if (!response?.data) return;

      const array =
        +user.role?.roleLable === 1 || +user.role?.roleLable === 2
          ? response.data
          : response.data.filter(
              (d) =>
                +d.ownerId === +user.id ||
                d.participants.find(
                  (p) =>
                    +p.userId === +user.id ||
                    p.email.toLowerCase() === user.email.toLowerCase()
                )
            );

      setEvents(
        array
          .filter((d) => d.eventStatus !== "Draft")
          .map((d, i) => ({ ...d, title: d.event?.name, eventDate: d.date }))
      );
    });
  }, [siteId, user.id, user.role, user.email]);

  return (
    <>
      {/* {hideMenuTabs ? null : <MeetingMenu active={1} siteId={siteId} />} */}
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "OHSE Review",
            path: "/health-safety-and-environment/audits-meetings",
          },
          { name: "OHSE Review Calendar" },
        ]}
        module={ACTIVE_MODULE.ohse}
      />
      <div className="card p-3 mt-4">
        <div className="simple-card-title pr-3">
          {hideMenuTabs ? null : (
            <h2 className="text-capitalize mb-1">My Meetings Calendar</h2>
          )}
          {/* <span style={{ height: 15, width: 15 }} className={`ml-auto ${getStatusClass("Scheduled")}`} />
          <span className="ml-1 mr-5">Scheduled</span>
          <span style={{ height: 15, width: 15 }} className={`${getStatusClass("In Progress")}`} />
          <span className="ml-1 mr-5">In Progress</span>
          <span style={{ height: 15, width: 15 }} className={`${getStatusClass("Completed")}`} />
          <span className="ml-1 mr-5">Completed</span>
          <span style={{ height: 15, width: 15 }} className={`${getStatusClass("Overdue")}`} />
          <span className="ml-1 mr-auto">Overdue</span> */}
          {hideMenuTabs ? null : (
            <BackBtn
              url={`${
                siteId ? `/sites/${siteId}` : ""
              }/health-safety-and-environment/audits-meetings`}
            />
          )}
        </div>
        <FullCalendar
          eventContent={renderEventContent}
          events={events}
          plugins={[dayGridPlugin]}
          initialView="dayGridMonth"
          dateClick={() => {}}
        />
        ;
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(MeetingsCalendar);
